import React, { useEffect, useState } from "react";
import TotalOtpsCountGraphV2 from "./TotalOtpsCountGraphV2";
import PerTeamOtpsCountGraphV2 from "./PerTeamOtpsCountGraphV2";
import { UserOutlined, ApiOutlined } from "@ant-design/icons";
import "./dashboardV2.css";

const ACTIVE_USER_API = "https://qzufib1cx8.execute-api.us-east-1.amazonaws.com/dev/active-user-count";

const DashboardV2 = () => {
  const [data, setData] = useState({
    active_user_count: null,
    current_month_otp_count: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(ACTIVE_USER_API);
        const result = await response.json();
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="dashboard-v2-container">
      <div className="dashboard-v2-stat-card">
        <span className="dashboard-v2-stat-icon">
          <UserOutlined />
        </span>
        <div className="dashboard-v2-stat-label">Active Testers</div>
        <div className={`dashboard-v2-stat-value ${data.active_user_count === null ? "loading" : ""}`}>
          {data.active_user_count !== null ? data.active_user_count.toLocaleString() : "Loading..."}
        </div>
      </div>
      <div className="dashboard-v2-stat-card">
        <span className="dashboard-v2-stat-icon">
          <ApiOutlined />
        </span>
        <div className="dashboard-v2-stat-label">Current Month OTPs</div>
        <div className={`dashboard-v2-stat-value ${data.current_month_otp_count === null ? "loading" : ""}`}>
          {data.current_month_otp_count !== null ? data.current_month_otp_count.toLocaleString() : "Loading..."}
        </div>
      </div>
      <TotalOtpsCountGraphV2
        title="Total OTPs Count"
        apiEndpoint="https://tg5n48dww1.execute-api.us-east-1.amazonaws.com/dev/all-opts-count-day-wise"
      />
      <PerTeamOtpsCountGraphV2
        title="Per Team OTPs Count"
        apiEndpoint="https://tg5n48dww1.execute-api.us-east-1.amazonaws.com/dev/team-opts-count-day-wise"
      />
    </div>
  );
};

export default DashboardV2;
